import { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { adminApi, formatApiError } from "../adminApi";

const FIELD = "w-full rounded-lg border border-[#E5E7EB] px-4 py-2.5 text-sm focus:outline-none focus:border-[#1E88E5] transition";

export default function AdminChangePassword() {
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (np.length < 8) return setError("New password must be at least 8 characters");
    if (np !== confirm) return setError("Passwords do not match");
    setSaving(true);
    try {
      await adminApi.post("/auth/change-password", { current_password: cur, new_password: np });
      toast.success("Password changed successfully");
      setCur(""); setNp(""); setConfirm("");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-lg" data-testid="admin-change-password">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#0A2342]">Change Password</h1>
        <p className="text-sm text-[#4B5563] mt-1">Update your account password.</p>
      </div>
      <form onSubmit={submit} className="bg-white rounded-xl border border-[#E5E7EB] p-6 space-y-4">
        <div>
          <label className="block text-sm font-semibold text-[#0A2342] mb-1.5">Current Password</label>
          <input data-testid="cp-current" type="password" className={FIELD} value={cur} onChange={(e) => setCur(e.target.value)} required />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#0A2342] mb-1.5">New Password</label>
          <input data-testid="cp-new" type="password" className={FIELD} value={np} onChange={(e) => setNp(e.target.value)} required />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#0A2342] mb-1.5">Confirm New Password</label>
          <input data-testid="cp-confirm" type="password" className={FIELD} value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        </div>
        {error && <p className="text-sm text-red-700">{error}</p>}
        <button data-testid="cp-submit" disabled={saving} className="inline-flex items-center gap-2 rounded-lg bg-[#0A2342] text-white px-6 py-3 font-semibold hover:bg-[#1E88E5] transition-colors disabled:opacity-60">
          {saving ? <Loader2 size={18} className="animate-spin" /> : <KeyRound size={18} />} Update Password
        </button>
      </form>
    </div>
  );
}
